import _defineProperty from "@babel/runtime/helpers/defineProperty";
import languagesConfig from '@datacamp/dc-languages-config';
export class UserInput {
  constructor(_ref) {
    let {
      inputNumber,
      language,
      value
    } = _ref;
    _defineProperty(this, "inputNumber", void 0);
    _defineProperty(this, "language", void 0);
    _defineProperty(this, "value", void 0);
    this.inputNumber = inputNumber;
    this.language = language;
    this.value = value;
  }
  static getPrompt(language, inputNumber) {
    return languagesConfig[language].prompt(inputNumber).trim();
  }
  get prompt() {
    return UserInput.getPrompt(this.language, this.inputNumber);
  }
  get outputLabel() {
    return languagesConfig[this.language].outputLabel(this.inputNumber).trim() || undefined;
  }
}